<template>
  <div>
    TODO
  </div>
</template>

<script>
export default {
  name: 'TeacherUsers',
  data: () => ({
  }),
  methods: {
  },
};
</script>

<style>

</style>
